<script setup lang="ts">
import CitationList from './CitationList.vue'
import ConversationActions from './ConversationActions.vue'
import type { Citation, Conversation } from '../types'

defineProps<{
  nickname: string
  username: string
  conversations: Conversation[]
  currentId?: string
  citations: Citation[]
  open?: boolean
}>()

const emit = defineEmits<{
  newConversation: []
  select: [id: string]
  logout: []
  close: []
  renamed: [conversation: Conversation]
}>()
</script>

<template>
  <aside class="sidebar" :class="{ open }">
    <div class="brand">
      <div class="brand-mark">
        <span class="beta-symbol" aria-label="beta hat">β</span>
      </div>
      <div>
        <strong>计量客栈</strong>
        <span>Econometrics Inn</span>
        <small class="brand-author">by SKY Labs</small>
      </div>
      <button class="mobile-close" type="button" aria-label="关闭侧边栏" @click="emit('close')">
        ×
      </button>
    </div>

    <section class="profile-card">
      <p class="eyebrow">你的化名</p>
      <h2>{{ nickname }}</h2>
      <span>{{ username }}</span>
    </section>

    <button class="new-chat" type="button" @click="emit('newConversation')">
      <span>＋</span> 新建学习对话
    </button>

    <nav class="history">
      <p class="sidebar-title">历史对话</p>
      <div class="history-row"
        v-for="conversation in conversations"
        :key="conversation.id"
      ><button
        type="button"
        :class="{ active: conversation.id === currentId }"
        @click="emit('select', conversation.id)"
      >
        <span>{{ conversation.title }}</span>
        <small>{{ conversation.message_count }} 轮</small>
      </button><ConversationActions :conversation="conversation" @renamed="emit('renamed', $event)" /></div>
      <p v-if="!conversations.length" class="empty-sidebar">
        还没有历史对话，从一个概念开始吧。
      </p>
    </nav>

    <section class="reference-panel">
      <p class="sidebar-title">本轮参考章节</p>
      <CitationList :citations="citations.slice(0, 3)" compact />
      <p v-if="!citations.length" class="empty-sidebar">
        提问后，这里会显示教材来源。
      </p>
    </section>

    <button class="logout-button" type="button" @click="emit('logout')">退出账号</button>
  </aside>
  <button
    v-if="open"
    class="sidebar-scrim"
    type="button"
    aria-label="关闭侧边栏"
    @click="emit('close')"
  ></button>
</template>
